// blog navigation tool
$(function () {
    $(document).delegate('.blog4-nav__card', 'click', function () {
        window.location = $(this).find('a').attr('href')
    })
})

// blog overview
$(function () {
    // @ vars ----------------------------------------------
    const blog_overlay = document.querySelector('.blog4__dialog-overlay')

    if (blog_overlay === null) {
        return
    }

    const btn_more_css_selector = '.blog4__btn-load-more'
    const class_visible = 'blog4__dialog-overlay--is-visible'
    const url = CCM_REL + '/index.php/tools/packages/blog_v4/ajax.php'

    const blog_cards = document.querySelector('.blog4__cards')
    const blog_chips = document.querySelector('.blog4__chips')
    const btn_apply_filter = document.querySelector('.blog4__btn-apply-filter')
    const btn_clear_filter = document.querySelector('.blog4__btn-clear-filter')
    const btn_dialog_open_mobile = document.querySelector('.blog4__toolbar--bottom .blog4__btn-filter')
    const dialog_chips = document.querySelector('.blog4__dialog-chips')
    const dialog_close = document.getElementById('blog4-dialog-close')
    const filters_ages = document.querySelector('.blog4__dialog-filters--ages')
    const filters_tags = document.querySelector('.blog4__dialog-filters--tags')
    const input_search = document.querySelector('.blog4__dialog-search')
    const site_footer = document.querySelector('.site-footer')
    const span_apply_filter = document.querySelector('.blog4__btn-apply-filter > span')
    const div_toolbar_top = document.querySelector('.blog4__toolbar--top')
    const div_toolbar_bottom = document.querySelector('.blog4__toolbar--bottom')

    const inputs_ages = filters_ages.querySelectorAll('input[type=checkbox]')
    const inputs_tags = filters_tags.querySelectorAll('input[type=checkbox]')

    const coords = {
        window_y: 0,
        site_footer_top: 0,
        btn_filter_top: 0,
    }

    const filter_data = {
        action: 'get blogs limited',
        instance_id: null,
        age_ids: [],
        tag_ids: [],
        limit: 20,
    }

    const num_blogs = {
        filtered: 0,
        instance: 0,
        limit: 0,
        visible: 0,
    }

    // @ funcs ---------------------------------------------
    function sendData(data, type = 'html') {
        return $.ajax({
            url: url,
            data: data,
            type: 'GET',
            dataType: type,
        })
    }

    const getAgeIdArray = () => {
        const checkboxes = document
            .querySelector('.blog4__dialog-filters--ages')
            .querySelectorAll('input[type="checkbox"]:checked')
        const checked_values = []

        checkboxes.forEach((checkbox) => {
            checked_values.push(checkbox.value)
        })

        return checked_values
    }

    const getTagIdArray = () => {
        const checkboxes = document
            .querySelector('.blog4__dialog-filters--tags')
            .querySelectorAll('input[type="checkbox"]:checked')
        const checked_values = []

        checkboxes.forEach((checkbox) => {
            checked_values.push(checkbox.value)
        })

        return checked_values
    }

    const updateCheckboxes = (checkboxes, ids) => {
        checkboxes.forEach((checkbox) => {
            const checkbox_state = ids.includes(checkbox.value)
            if (checkbox.checked !== checkbox_state) {
                checkbox.checked = checkbox_state
                // trigger click event, so chips will update accordingly
                checkbox.dispatchEvent(new Event('click'))
            }
        })
    }

    const debouncedSearch = _.debounce((e) => {
        inputs_tags.forEach((input) => {
            if (input.getAttribute('data-chip-txt').indexOf(input_search.value.toLowerCase()) === -1) {
                input.parentElement.style.display = 'none'
            } else {
                input.parentElement.style.display = 'flex'
            }
        })
    }, 700)

    const debouncedScroll = _.debounce((e) => {
        if (window.innerWidth <= 768) {
            const footer_rect = site_footer.getBoundingClientRect()
            const footer_h_visible = parseInt(window.innerHeight - footer_rect.top)

            btn_dialog_open_mobile.style.bottom = footer_h_visible > 0 ? footer_h_visible + 10 + 'px' : '10px'
        }
    }, 50)

    const updateBtnApplyFilterTxt = () => {
        const btn_data = {
            action: 'get num blogs filtered',
            instance_id: filter_data.instance_id,
            age_ids: getAgeIdArray(),
            tag_ids: getTagIdArray(),
        }

        sendData(btn_data, 'json').done((json) => {
            num_blogs.filtered = json
            span_apply_filter.textContent = num_blogs.filtered
        })
    }

    const filterByCSSSelector = (html, selector) => {
        const div_tmp = document.createElement('div')
        div_tmp.innerHTML = html
        const elems = Array.from(div_tmp.children)
        const filtered = elems.filter((e) => e.classList.contains(selector))

        if (filtered.length === 1) {
            return filtered[0]
        }
    }

    // @ events ---------------------------------------------
    window.addEventListener('beforeunload', function (event) {
        localStorage.clear()
    })

    // make whole blog card in blog overview clickable
    $(document).delegate('.blog4__card', 'click', function () {
        window.location = $(this).find('a').attr('href')
    })

    $(document).on('click', '.blog4__btn-filter', (e) => {
        blog_overlay.classList.add(class_visible)
        document.body.classList.add(class_visible)

        const str_json = localStorage.getItem('filter_data')
        const json_parsed = JSON.parse(str_json)

        if (json_parsed !== null) {
            updateCheckboxes(inputs_ages, json_parsed.age_ids)
            updateCheckboxes(inputs_tags, json_parsed.tag_ids)
        } else {
            updateCheckboxes(inputs_ages, filter_data.age_ids)
            updateCheckboxes(inputs_tags, filter_data.tag_ids)
        }
    })

    dialog_close.addEventListener('click', (e) => {
        blog_overlay.classList.remove(class_visible)
        document.body.classList.remove(class_visible)
    })

    btn_apply_filter.addEventListener('click', (e) => {
        e.preventDefault()
        filter_data.age_ids = getAgeIdArray()
        filter_data.tag_ids = getTagIdArray()

        const str_json = JSON.stringify(filter_data)
        localStorage.setItem('filter_data', str_json)

        sendData(filter_data).done((html) => {
            dialog_close.click()
            div_toolbar_top.innerHTML = filterByCSSSelector(html, 'blog4__toolbar--top').innerHTML
            blog_cards.innerHTML = filterByCSSSelector(html, 'blog4__cards').innerHTML
            div_toolbar_bottom.innerHTML = filterByCSSSelector(html, 'blog4__toolbar--bottom').innerHTML

            blog_chips.innerHTML = dialog_chips.innerHTML
            blog_chips.querySelectorAll('span').forEach((span) => {
                span.classList.remove('blog4__dialog-chip')
                span.classList.add('blog4__chip')
            })
        })
    })

    btn_clear_filter.addEventListener('click', (e) => {
        e.preventDefault()
        updateCheckboxes(inputs_ages, [])
        updateCheckboxes(inputs_tags, [])
    })

    $(document).on('click', '.blog4__chip[data-age-id] button', (e) => {
        const age_id_to_remove = e.target.getAttribute('data-age-id')
        filter_data.age_ids = filter_data.age_ids.filter((age_id) => age_id !== age_id_to_remove)
        updateCheckboxes(inputs_ages, filter_data.age_ids)
        btn_apply_filter.dispatchEvent(new Event('click'))
    })

    $(document).on('click', '.blog4__chip[data-tag-id] button', (e) => {
        const tag_id_to_remove = e.target.getAttribute('data-tag-id')
        filter_data.tag_ids = filter_data.tag_ids.filter((tag_id) => tag_id !== tag_id_to_remove)
        updateCheckboxes(inputs_tags, filter_data.tag_ids)
        btn_apply_filter.dispatchEvent(new Event('click'))
    })

    $(document).on('click', btn_more_css_selector, (e) => {
        e.preventDefault()

        const btn_more = document.querySelector(btn_more_css_selector)
        filter_data.limit = parseInt(btn_more.getAttribute('data-limit'))

        sendData(filter_data).done((html) => {
            blog_cards.innerHTML = filterByCSSSelector(html, 'blog4__cards').innerHTML
            div_toolbar_bottom.innerHTML = filterByCSSSelector(html, 'blog4__toolbar--bottom').innerHTML

            const btn_more = document.querySelector(btn_more_css_selector)
            btn_more.setAttribute('data-limit', filter_data.limit + 20)
        })
    })

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            dialog_close.click()
        }
    })

    inputs_ages.forEach((input) => {
        input.addEventListener('click', (e) => {
            if (input.checked) {
                const txt = document.createTextNode(input.getAttribute('data-chip-txt'))
                const chip = document.createElement('span')
                const btn_close = document.createElement('button')
                chip.className = 'blog4__dialog-chip'
                btn_close.className = 'btn-close'
                chip.setAttribute('data-age-id', input.value)
                btn_close.setAttribute('data-age-id', input.value)

                chip.appendChild(txt)
                chip.appendChild(btn_close)
                dialog_chips.appendChild(chip)

                btn_close.addEventListener('click', (e) => {
                    chip.remove()
                    filters_ages.querySelector('[value="' + input.value + '"]').checked = false
                })
            } else {
                const span_to_remove = dialog_chips.querySelector('span[data-age-id="' + input.value + '"]')
                span_to_remove.remove()
            }

            const data = {
                action: 'get topic ids by age ids',
                age_ids: getAgeIdArray(),
            }

            sendData(data, 'json').done((tag_ids) => {
                inputs_tags.forEach((input) => {
                    if (tag_ids.length === 0 || tag_ids.includes(parseInt(input.value))) {
                        input.parentElement.style.display = 'flex'
                    } else {
                        input.parentElement.style.display = 'none'
                    }
                })
            })

            updateBtnApplyFilterTxt()
        })
    })

    inputs_tags.forEach((input) => {
        input.addEventListener('click', (e) => {
            if (input.checked) {
                const txt = document.createTextNode(input.getAttribute('data-chip-txt'))
                const chip = document.createElement('span')
                const btn_close = document.createElement('button')
                chip.className = 'blog4__dialog-chip'
                btn_close.className = 'btn-close'
                chip.setAttribute('data-tag-id', input.value)
                btn_close.setAttribute('data-tag-id', input.value)

                chip.appendChild(txt)
                chip.appendChild(btn_close)
                dialog_chips.appendChild(chip)

                btn_close.addEventListener('click', (e) => {
                    chip.remove()
                    filters_tags.querySelector('[value="' + input.value + '"]').checked = false
                })
            } else {
                const span_to_remove = dialog_chips.querySelector('span[data-tag-id="' + input.value + '"]')
                span_to_remove.remove()
            }

            updateBtnApplyFilterTxt()
        })
    })

    input_search.addEventListener('input', debouncedSearch)
    window.addEventListener('scroll', debouncedScroll)

    // @ inits -----------------------------------------------
    filter_data.instance_id = blog_cards.getAttribute('data-instance-id')
})
